import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PlantYourActivityLayer from "../components/PlantYourActivityLayer";

const PlantYourActivityTablePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Your Activity" tooltipContent="Add New Complaint" linkTo="/complains/add"  requiredPermission={{ module: 'complaints', action: 'create' }}/>
    
        {/* TableDataLayer */}
        <PlantYourActivityLayer />

      </MasterLayout>

    </>
  );
};

export default PlantYourActivityTablePage; 
